import cn from 'classnames';
import React, { useEffect, useState } from 'react';

import dayjs from 'lib/dayjs-setup';

import styles from './styles.module.scss';

const parseDate = (startDate: string, endDate: string): [string, number] => {
  const diff = dayjs(endDate).diff(dayjs(startDate));
  const time = dayjs.duration(diff);
  const days = dayjs(endDate).diff(dayjs(startDate), 'days');
  const hours = time.hours().toString().padStart(2, '0');
  const minutes = time.minutes().toString().padStart(2, '0');
  const seconds = time.seconds().toString().padStart(2, '0');

  return [`${days ? `${days}d ` : ''}${hours}:${minutes}:${seconds}`, diff];
};

const end = '00:00:00';

export const TimerBetween: React.FC<{
  endDate: string;
  onEnd?: () => void;
  onError?: () => void;
  className?: string;
  removeAfterFinish?: boolean;
  isReturnString?: boolean;
}> = ({ endDate, onEnd, onError, className, removeAfterFinish, isReturnString = false }) => {
  const [timeString, setTimeString] = useState(
    parseDate(dayjs().toString(), endDate)[0],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const [parsedDate, remainingTime] = parseDate(
        dayjs().toString(),
        endDate,
      );
      let date = parsedDate;

      if (remainingTime <= 0) {
        // Когда закончился таймер
        date = end;
        setTimeString(date);
        clearInterval(interval);
        onEnd?.();

        return;
      }

      if (remainingTime < 0) {
        // Если что-то пошло не так (например, дата окончания раньше даты начала)
        clearInterval(interval);
        onError?.();

        return;
      }

      setTimeString(date);
    }, 1000);

    return () => clearInterval(interval);
  }, [onEnd, onError, endDate]);

  if (removeAfterFinish && (timeString === end || timeString.startsWith('-'))) {
    return null;
  }

  if (isReturnString) {
    return (
      <>
        {timeString}
      </>
    );
  }

  const content = timeString.split('').map((char, index) => {
    return /[a-zA-Zа-яА-Я]/.test(char) ? (
      <span key={index}>{char}</span>
    ) : (
      char
    );
  });

  return <div className={cn(styles.container, className)}>{content}</div>;
};

export default TimerBetween;
